export const SET_FILTER_STATE = "SET_FILTER_STATE";

export function setFilterState(filterState: any) {
    return {
        type: SET_FILTER_STATE,
        payload: filterState
    };
}